<template>
  <AccountIconWh104 :image-url="imageUrl" />
</template>

<script>
import AccountIconWh104 from '../../components/atoms/account_icons/AccountIconWh104'
export default {
  components: { AccountIconWh104 },
  data() {
    return {
      imageUrl: ''
    }
  }
}
</script>
